 $(document).ready(function(){

 	/*********************************
 	************* SIDENAV ************
	*********************************/
 	$(".button-collapse").sideNav({
 		draggable: false
 	});


	/*********************************
 	************ PARALLAX ************
	*********************************/
 	$('.parallax').parallax();

 	/*********************************
 	********** COLLAPSIBLE ***********
	*********************************/
 	$('.collapsible').collapsible();

 	/*********************************
 	************* SCROLL *************
	*********************************/
 	var $document = $(document),
    $element = $('#nav-menu-top, #page-top, .nav-wrapper'),
    className = 'scroll';

	$document.scroll(function() {
		if ($document.scrollTop() >= 60) {
			$element.addClass(className);
			$(".page-top-icon").click(function(e) {
				e.preventDefault();
			});
		} else {
			$element.removeClass(className);
		}
	});
	$("#nav-menu-top-logo").click(function(event) {
		if ($document.scrollTop() < 60) {
			event.preventDefault();
		}
	});

	$(".page-top-icon").click(function() {
		if ($document.scrollTop() < 60) {
			$('html, body').animate({
				scrollTop: $("#home-philosophie").offset().top - 52
			}, 600);
		}
	});


	/**********************************
	********* HEADER MOBILE ***********
	**********************************/
	$("#page-nav a.button-collapse, .drag-target").click(function() {
		$('#page-nav .button-collapse').toggleClass('open')
		if ($document.scrollTop() < 60) {
			if ($('#page-nav > .nav-wrapper').hasClass('scroll')) {
				$("#page-nav > .nav-wrapper").removeClass('scroll');
			} else {
				$("#page-nav > .nav-wrapper").addClass('scroll');
			}
		}
	});

	/**********************************
	************ SWIPEBOX**************
	**********************************/
	$('.swipebox').swipebox();

	/**********************************
	*************** REVEAL ************
	**********************************/
	window.sr = ScrollReveal({mobile: false, duration: 800, distance: '80px', scale: '1', viewFactor: 0.3});
	// HOME
	sr.reveal('#home-philosophie-citation', {origin: 'bottom'});
	sr.reveal('#home-presentation-img', {origin: 'bottom'});
	sr.reveal('#home-presentation-text', {origin: 'right'});
	sr.reveal('#home-profil h4', {origin: 'top'});
	sr.reveal('#home-profil .row .col:nth-child(2n+1)', {origin: 'left'});
	sr.reveal('#home-profil .row .col:nth-child(2n)', {origin: 'right'});
	sr.reveal('#page-footer-contact-text', {origin: 'bottom',  viewFactor: 1});
	sr.reveal('#page-footer-reseaux-sociaux a', {origin: 'right', viewFactor: 1}, 80);
	// PRESENTATION
	sr.reveal('#presentation-bio .row', {origin: 'left'});
	sr.reveal('#presentation-formation .row', {origin: 'right'});
	sr.reveal('#presentation-experience h4', {distance: '0px'});
	sr.reveal('#presentation-experience .row .col:nth-child(2n)', {origin: 'right'});
	sr.reveal('#presentation-experience .row .col:nth-child(2n+1)', {origin: 'left'});
	sr.reveal('#presentation-cv', {origin: 'bottom'});
	// PRESTATIONS
	sr.reveal('.prestation-titre', {distance: '0px'});
	sr.reveal('.prestation-item:nth-child(2n)', {origin: 'right'});
	sr.reveal('.prestation-item:nth-child(2n+1)', {origin: 'left'});
	// MEDIA
	sr.reveal('.media-titre', {distance: '0px'});
	sr.reveal('.video-item', {origin: 'bottom'}, 80);
	sr.reveal('.photo-item', {origin: 'bottom'}, 80);
	sr.reveal('.presse-item:nth-child(2n)', {origin: 'right', delay: 400});
	sr.reveal('.presse-item:nth-child(2n+1)', {origin: 'left'});
	// EVENEMENTS
	sr.reveal('#evenement-venir .evenement-titre', {distance: '0px'});
	sr.reveal('#evenement-venir .evenement-item:nth-child(2n)', {origin: 'right'});
	sr.reveal('#evenement-venir .evenement-item:nth-child(2n+1)', {origin: 'left'});
	// CONTACT
	sr.reveal('#contact-content > .container > p', {distance: '0px'});
	sr.reveal('#contact-form', {origin: 'bottom',  viewFactor: 0.2});
	sr.reveal('#contact-infos', {origin: 'right', viewFactor: 1});
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/main.js
// module id = 0
// module chunks = 0